import 'typeface-roboto'
import axios from 'axios';
// need all ant css for widgets
//import 'antd/dist/reset.css';
  
global.$ = require('jquery');
global.jquery = window.$;
global.jQuery = window.$;

require('angular');
require('angular-route');
require('angular-cookies');
require('angular-animate');
require('react');
global['react-dom'] = require('react-dom');
global.redux = require('redux');
global.lodash = require('lodash');

require('ng-redux');
require('redux-saga');
require('react2angular');
require('@progress/kendo-ui');

global.React = require('react');
global.react = window.React;
global['react-redux'] = require('react-redux');
global.axios = axios;
global.styled = require('styled-components');
global['styled-components'] = require('styled-components');
// global.less = require('less');
global.antd = require('antd');
global['array-move'] = require('array-move');

global.msal = require('@azure/msal-browser');

// global.reactFontawesome = require('@fortawesome/react-fontawesome');
// global.fontawesomeSvgCore = require('@fortawesome/fontawesome-svg-core');
// global.proSolidSvgIcons = require('@fortawesome/pro-solid-svg-icons');
